export const newsList = [
  {
    id: "016",
    date: "2026.10.26",
    category: "お知らせ",
    title: "【ご報告】「Food Japan 2026」シンガポール出品終了のお礼とご報告",
    excerpt: "弊社ファーム事業部は2026年10月22日（木）～24日（土）の3日間、シンガポールにて開催された日本食品専門見本市「Food Japan 2026」へ、自社ブランドかぼす「乙御KABOS」を使用した「かぼすのグラノーラクッキー」を出品してまいりました。",
    image: "https://storage.helloreaddy.io/project_files/3947077b-25d2-4d94-b656-7a710d99b9c9/38643364-f8eb-422a-94e7-2dee3da98d0c_compressed_S__93822989_0.webp",
  },
  {
    id: "015",
    date: "2026.10.04",
    category: "お知らせ",
    title: "【弊社所属・森祐作の活動および業務提携に関するお知らせ】",
    excerpt: "このたび、弊社所属タレント森祐作が2026年10月より、大分県外での活動を開始することとなりました。福岡で新たに設立された芸能プロダクション「STAR RISE ENTERTAINMENT」と業務提携を結び、同社がマネジメントを担当することとなりました。",
    image: "https://storage.helloreaddy.io/project_files/3947077b-25d2-4d94-b656-7a710d99b9c9/02398040-a1d8-453b-8ef7-9b70ddbc1965_compressed_IMG_0940.webp",
  },
  {
    id: "014",
    date: "2026.10.02",
    category: "お知らせ",
    title: "【お知らせ】全日空ANAグループの「ANAアグリ部」の受け入れ拠点に決定いたしました！",
    excerpt: "この度、株式会社OLカンパニーが運営する大分県臼杵市乙見のかぼすファームが、全日本空輸株式会社（ANA）が展開する農業体験・実践サービス「ANAアグリ部」の受入拠点として決定いたしました。",
    image: "https://static.readdy.ai/image/8da10c853ee44f0b201c0b84a1169777/80fcb870e02f345712f3787f2a1ad93b.png",
  },
  {
    id: "013",
    date: "2026.09.27",
    category: "お知らせ",
    title: "【コラボ販売情報】乙御KABOS×雪国まいたけ！特別コラボ販売スタートのお知らせ",
    excerpt: "弊社の「乙御KABOS（おとみカボス）」と、旨みと食感が際立つ「雪国まいたけ」の夢のコラボレーションが実現いたしました！本コラボは、本日よりマルミヤストア 金池南店様にてお買い求めいただけます。",
    image: "https://storage.helloreaddy.io/project_files/3947077b-25d2-4d94-b656-7a710d99b9c9/3ae2e02d-57e7-42bd-8829-eb6a67043407_compressed_S__91709446_0.webp",
  },
  {
    id: "012",
    date: "2026.09.10",
    category: "お知らせ",
    title: "東京ミッドタウン日比谷「DRAWING HOUSE OF HIBIYA」にて、「乙御KABOS」をふんだんに使用したメニューがスタート！",
    excerpt: "このたび、東京ミッドタウン日比谷6階に店舗を構える人気レストラン「DRAWING HOUSE OF HIBIYA」にて、弊社ブランドかぼす「乙御KABOS」を採用していただけることが決定いたしました。",
    image: "https://storage.helloreaddy.io/project_files/3947077b-25d2-4d94-b656-7a710d99b9c9/dd64a112-3223-4616-9138-7dee576cc178_compressed_S__90923015_0.webp",
  },
  {
    id: "011",
    date: "2026.09.01",
    category: "お知らせ",
    title: "【お知らせ】ANA限定返礼品に採択！臼杵市の返礼品として初の 「ANA限定バッジ」を取得！",
    excerpt: "このたび、弊社の贈答用「乙御KABOS（24玉入り）」が、全日空ANAが運営する「ANAのふるさと納税」において「ANA限定返礼品」に採択されました。",
    image: "https://storage.helloreaddy.io/project_files/3947077b-25d2-4d94-b656-7a710d99b9c9/847e0d5d-7f7e-4069-ad37-6a5b387380b3_compressed_n1.webp",
  },
  {
    id: "010",
    date: "2026.09.01",
    category: "お知らせ",
    title: "【新商品販売開始のお知らせ】",
    excerpt: "このたび、公式ECサイト・ならびに臼杵市ふるさと納税にて「乙御KABOS（おとみカボス）」贈答用の販売を開始いたしました。",
    image: "https://storage.helloreaddy.io/project_files/3947077b-25d2-4d94-b656-7a710d99b9c9/1bd9f269-eadb-483c-adf0-dec8836c886c_compressed_n.webp",
  },
  {
    id: "009",
    date: "2026.08.29",
    category: "お知らせ",
    title: "【8/29 (土) アパレルブランド THANKSLOCAL RELEASE！】",
    excerpt: "弊社のローカルアパレルブランド「THANKSLOCAL」から、今シーズンの新作Tシャツ2パターンが、本日より公式ECサイトにて販売スタートしました！",
    image: "https://storage.helloreaddy.io/project_files/3947077b-25d2-4d94-b656-7a710d99b9c9/60988106-e21d-4216-ae58-86f45e370760_compressed_S__89645071_0.webp",
  },
  {
    id: "008",
    date: "2026.08.01",
    category: "お知らせ",
    title: "【乙御KABOSが福岡県へ！】カフェ＆コミュニティスペース dot. にてお取扱い開始",
    excerpt: "現在自社ブランド「乙御KABOS」を福岡市天神大名にあるカフェ＆コミュニティスペース dot.（ドット）さんでお取り扱いしていただいております。",
    image: "https://storage.helloreaddy.io/project_files/3947077b-25d2-4d94-b656-7a710d99b9c9/68cb4847-18a8-4278-ab7f-999bf419c997_compressed_S__89407535_0.webp",
  },
  {
    id: "007",
    date: "2026.08.01",
    category: "お知らせ",
    title: "【販売情報】大分県内スーパーマーケットで乙御KABOS取扱い開始",
    excerpt: "このたび、かぼす発祥の地・大分県臼杵市産の「乙御KABOS（おとみカボス）」が、大分県内のスーパーマーケットにおきましてもお買い求めいただけることとなりました。",
    image: "https://storage.helloreaddy.io/project_files/3947077b-25d2-4d94-b656-7a710d99b9c9/15d34f39-863c-4177-9eee-afbbb5502240_compressed_S__89407529_0.webp",
  },
  {
    id: "006",
    date: "2026.08.01",
    category: "お知らせ",
    title: "【乙御KABOS販売情報】公式ECサイトがオープン",
    excerpt: "かねてより準備を進めてまいりました「株式会社OLカンパニー 公式ECサイト」が正式にオープンいたしました。",
    image: "https://storage.helloreaddy.io/project_files/3947077b-25d2-4d94-b656-7a710d99b9c9/948915cd-23a8-4ce2-8cd0-19133630ea78_compressed_S__89407524_0.webp",
  },
  {
    id: "005",
    date: "2026.06.12",
    category: "お知らせ",
    title: "森祐作代表が「うすきカボス応援大使」に就任",
    excerpt: "株式会社OLカンパニー代表取締役兼タレントの森祐作が、臼杵市の「うすきカボス応援大使」に就任いたしました。",
    image: "https://storage.readdy-site.link/project_files/3947077b-25d2-4d94-b656-7a710d99b9c9/280df029-6b36-47dd-ac2b-e88dd0be4902_S__85295107_0.jpg",
  },
  {
    id: "004",
    date: "2026.04.20",
    category: "イベント",
    title: "春の収穫体験イベント開催",
    excerpt: "ファーム事業にて春の収穫体験イベントを開催いたします。ぜひご参加ください。",
    image: "https://static.readdy.ai/image/8da10c853ee44f0b201c0b84a1169777/ecac0c54302831045c8622edaa0f95e7.webp",
  },
];

interface ContentBlock {
  type: "subheading" | "paragraph" | "image" | "list";
  text?: string;
  src?: string;
  alt?: string;
  items?: string[];
}

export interface ArticleDetail {
  id: string;
  date: string;
  category: string;
  title: string;
  image: string;
  blocks: ContentBlock[];
}

export const newsDetail: Record<string, ArticleDetail> = {
  "016": {
    id: "016",
    date: "2026.10.26",
    category: "お知らせ",
    title: "【ご報告】「Food Japan 2026」シンガポール出品終了のお礼とご報告",
    image: "https://storage.helloreaddy.io/project_files/3947077b-25d2-4d94-b656-7a710d99b9c9/38643364-f8eb-422a-94e7-2dee3da98d0c_compressed_S__93822989_0.webp",
    blocks: [
      { type: "paragraph", text: "弊社ファーム事業部は2026年10月22日（木）～24日（土）の3日間、シンガポールにて開催された日本食品専門見本市「Food Japan 2026」へ、自社ブランドかぼす「乙御KABOS」を使用した「かぼすのグラノーラクッキー」を出品してまいりました。" },
      { type: "image", src: "https://storage.helloreaddy.io/project_files/3947077b-25d2-4d94-b656-7a710d99b9c9/f676a2a6-f53a-419f-a026-c94961d27322_compressed_S__93822988_0.webp", alt: "Food Japan 2026 かぼすのグラノーラクッキー 出品ビジュアル" },
      { type: "subheading", text: "現地で多くの反響をいただいた3日間" },
      { type: "paragraph", text: "会期中は現地ASEANをはじめとする各国のバイヤーや食の事業者、一般の来場者の皆様に弊社商品をお試しいただく貴重な機会となりました。" },
      { type: "paragraph", text: "大分の代表的な特産品である「かぼす」、そしてその発祥の地・臼杵市乙見で私たちが育てた「乙御KABOS」の爽やかな風味が広がるグラノーラクッキーは、現地でも非常に良い反応と高い関心をいただくことができました。" },
      { type: "image", src: "https://storage.helloreaddy.io/project_files/3947077b-25d2-4d94-b656-7a710d99b9c9/40981d9e-b9b6-4f31-b9de-5608dfc9bf58_compressed_S__93822994_0.webp", alt: "Food Japan 2026 会場に展示された乙御KABOSのかぼすのグラノーラクッキー" },
      { type: "image", src: "https://storage.helloreaddy.io/project_files/3947077b-25d2-4d94-b656-7a710d99b9c9/cd62d8fe-e302-4665-a5c8-851d7f4c20be_compressed_S__93822995_0.webp", alt: "ブースで商品をお試しいただく来場者の皆様" },
      { type: "subheading", text: "「Food Japan 2026」とは" },
      { type: "paragraph", text: "「Food Japan」は、ASEAN地域における日本食品の専門見本市として、シンガポールのサンテック・シンガポール国際会議展示場（Suntec Singapore）にて開催されました。日本の食・技術・サービスが一堂に集まる場として、各国のバイヤーや食の事業者が来場されました。" },
      { type: "image", src: "https://storage.helloreaddy.io/project_files/3947077b-25d2-4d94-b656-7a710d99b9c9/f347d268-55a8-42db-83d7-4cc9b606e405_compressed_S__93822990_0.webp", alt: "Food Japan 2026 会場サイン" },
      { type: "subheading", text: "オープニングセレモニーと会場の熱気" },
      { type: "paragraph", text: "初日にはオープニングセレモニーが執り行われ、会場は多くの来場者と出展者で活気に満ちていました。日本の食の可能性を世界へ伝える、大きな熱気を肌で感じることができました。" },
      { type: "image", src: "https://storage.helloreaddy.io/project_files/3947077b-25d2-4d94-b656-7a710d99b9c9/dfecab70-6e22-4bb0-b856-b353342c391a_compressed_S__93822993_0.webp", alt: "Food Japan 2026 オープニングセレモニーの様子" },
      { type: "image", src: "https://storage.helloreaddy.io/project_files/3947077b-25d2-4d94-b656-7a710d99b9c9/6da45925-7ec0-4a3c-bc30-143ed79374cf_compressed_S__93822991_0.webp", alt: "Food Japan 2026 会場の各ブースの様子" },
      { type: "image", src: "https://storage.helloreaddy.io/project_files/3947077b-25d2-4d94-b656-7a710d99b9c9/9d41f00f-3829-4486-8d8b-11b4e2abdddc_compressed_S__93822996_0.webp", alt: "ブースにて商品をご説明する様子" },
      { type: "subheading", text: "海外市場への挑戦を、これからも" },
      { type: "paragraph", text: "今回の出品を通じて、現地市場の生のニーズや海外展開における実情を肌で感じることができ、非常に多くの学びと大きな収穫を得る3日間となりました。" },
      { type: "paragraph", text: "弊社が掲げる「ローカルの輝きを世界にシェアする」という理念の実現に向け、今回の経験と実りある成果を糧として、今後も大分の恵みを世界へと届けるべく、海外市場への挑戦を愚直に続けてまいります。" },
      { type: "paragraph", text: "現地で弊社商品にお手を触れていただいた皆様、そして日頃より温かく応援してくださっている皆様に、心より感謝申し上げます。" },
      { type: "paragraph", text: "今後とも変わらぬご支援とご愛顧を賜りますよう、よろしくお願い申し上げます。" },
      { type: "paragraph", text: "株式会社OLカンパニー　ファーム事業部" },
    ],
  },
  "015": {
    id: "015",
    date: "2026.10.04",
    category: "お知らせ",
    title: "【弊社所属・森祐作の活動および業務提携に関するお知らせ】",
    image: "https://storage.helloreaddy.io/project_files/3947077b-25d2-4d94-b656-7a710d99b9c9/02398040-a1d8-453b-8ef7-9b70ddbc1965_compressed_IMG_0940.webp",
    blocks: [
      { type: "paragraph", text: "平素より株式会社OLカンパニーならびに森祐作を応援いただき、誠にありがとうございます。" },
      { type: "paragraph", text: "このたび、弊社所属タレント森祐作が2026年10月より、大分県外での活動を開始することとなりましたのでお知らせいたします。" },
      { type: "subheading", text: "福岡での活動から20年、新たな挑戦へ" },
      { type: "paragraph", text: "森祐作は21歳のときに東京に本部を置く芸能プロダクションの福岡支部に入所し、福岡から活動をスタートさせました。" },
      { type: "paragraph", text: "その後上京し、東京を拠点に様々な経験を重ね、2014年からは故郷大分県でタレント活動を続けてまいりました。" },
      { type: "paragraph", text: "本年は活動20年という大きな節目の年を迎え、自身の表現活動の原点である福岡をはじめとする県外でも新たな挑戦をスタートさせることとなりました。" },
      { type: "paragraph", text: "この構想は昨年夏頃より検討を重ね、同年秋に県外での活動体制の構築に向けた準備をはじめました。また、今年に入り今後の県外での活動を見据え、現状の活動体制やスケジュールの見直しを行い、約1年にわたり準備を重ねてまいりました。" },
      { type: "image", src: "https://storage.helloreaddy.io/project_files/3947077b-25d2-4d94-b656-7a710d99b9c9/02398040-a1d8-453b-8ef7-9b70ddbc1965_compressed_IMG_0940.webp", alt: "森祐作 宣材写真" },
      { type: "subheading", text: "「STAR RISE ENTERTAINMENT」と業務提携" },
      { type: "paragraph", text: "これに伴い、森祐作の県外での活動につきましては、福岡で新たに設立された芸能プロダクション「STAR RISE ENTERTAINMENT（スターライズエンターテイメント）」と業務提携を結び、同社がマネジメントを担当することとなりました。" },
      { type: "paragraph", text: "株式会社OLカンパニーとスターライズエンターテイメントは、森祐作の今後の活動方針や将来像について慎重に協議を重ねてまいりました。その中で、同事務所の熱意と理念に共感し、双方の目指す方向性が一致したことから、業務提携という形で合意に至りました。" },
      { type: "subheading", text: "移籍ではなく、県外での活動における業務提携" },
      { type: "paragraph", text: "なお、今回のお知らせは移籍ではなく、県外での活動における業務提携となります。" },
      { type: "paragraph", text: "森祐作は引き続き株式会社OLカンパニーの所属タレントとして大分県に拠点を置きながら、今後に関しましては自身が大切にしたい表現やモノづくりを軸に活動を行い、表現者としてより一層精進してまいります。" },
      { type: "paragraph", text: "弊社といたしましても、森祐作の大切にしたい表現と誠実に向き合い全力で活動を支えてまいります。" },
      { type: "paragraph", text: "今後とも森祐作ならびに株式会社OLカンパニーへの変わらぬご支援、ご声援を賜りますようお願い申し上げます。" },
      { type: "image", src: "https://storage.helloreaddy.io/project_files/3947077b-25d2-4d94-b656-7a710d99b9c9/02398040-a1d8-453b-8ef7-9b70ddbc1965_compressed_IMG_0940.webp", alt: "森祐作 宣材写真" },
      { type: "paragraph", text: "2026年10月吉日 ／ 株式会社OLカンパニー　タレントマネジメント事業部" },
    ],
  },
  "014": {
    id: "014",
    date: "2026.10.02",
    category: "お知らせ",
    title: "【お知らせ】全日空ANAグループの「ANAアグリ部」の受け入れ拠点に決定いたしました！",
    image: "https://static.readdy.ai/image/8da10c853ee44f0b201c0b84a1169777/80fcb870e02f345712f3787f2a1ad93b.png",
    blocks: [
      { type: "paragraph", text: "この度、株式会社OLカンパニーが運営する大分県臼杵市乙見のかぼすファームが、全日本空輸株式会社（ANA）が展開する農業体験・実践サービス「ANAアグリ部」の受入拠点として決定いたしました。" },
      { type: "paragraph", text: "このような貴重な機会とご縁をいただきました全日空ANA関係者の皆様、ならびに本プロジェクトの推進にご尽力いただいたすべての方々に、心より深く感謝申し上げます。" },
      { type: "subheading", text: "「ANAアグリ部」とは" },
      { type: "paragraph", text: "「ANAアグリ部」は、ANAマイレージクラブ会員様を対象とした本格的な農業体験・実践サービスです。参加者が提携農家を訪れ、実際の農作業や地域体験を通じて食や農への理解を深める「大人の部活動」のような取り組みであり、地域と都市部を結ぶ関係人口の創出や地域活性化を目指されています。" },
      { type: "image", src: "https://static.readdy.ai/image/8da10c853ee44f0b201c0b84a1169777/80fcb870e02f345712f3787f2a1ad93b.png", alt: "ANAアグリ部 ようこそ、ANAアグリ部へ。" },
      { type: "subheading", text: "今年6月、ANA関係者の皆様が乙見のファームへ" },
      { type: "paragraph", text: "今年6月には、ANAの関係者の皆様に実際に臼杵市乙見の弊社ファームへ足をお運びいただきました。園地の環境や収穫に向けた育成状況、そして弊社の想いや取り組みを直接視察していただき、温かいご支援のもと、受け入れに向けた具体的な連携と準備を進めてまいりました。" },
      { type: "subheading", text: "11月より、待望の第1回プロジェクトが正式スタート" },
      { type: "paragraph", text: "そしていよいよ11月より、待望の第1回プロジェクトが正式にスタートいたします。" },
      { type: "image", src: "https://static.readdy.ai/image/8da10c853ee44f0b201c0b84a1169777/30b9851618e17eaef70f97fd0af9f825.png", alt: "11/21(土)開催イベント かぼすのふるさと大分県臼杵市乙見で かぼす収穫体験" },
      { type: "paragraph", text: "弊社は「ANAアグリ部」とのパートナーシップを通じて、歴史ある大分県のかぼす文化を次世代へ大切に受け継ぐとともに、本物の味覚とストーリーを持つブランドかぼす「乙御KABOS」の価値を全国・海外に広く届けてまいります。" },
      { type: "paragraph", text: "農業を通じた持続可能な地域振興と新たな関係人口の創出に向け、今後も全力で取り組んでまいります。" },
      { type: "image", src: "https://static.readdy.ai/image/8da10c853ee44f0b201c0b84a1169777/696bd8b0c012ee917ed4db70c28bb36f.png", alt: "ANAアグリ部 ロゴ" },
      { type: "subheading", text: "ANAアグリ部 公式サイト" },
      { type: "paragraph", text: "https://ana-agriculture-club.com/" },
      { type: "paragraph", text: "https://ana-agriculture-club.com/news/2664/" },
    ],
  },
  "013": {
    id: "013",
    date: "2026.09.27",
    category: "お知らせ",
    title: "【コラボ販売情報】乙御KABOS×雪国まいたけ！特別コラボ販売スタートのお知らせ",
    image: "https://storage.helloreaddy.io/project_files/3947077b-25d2-4d94-b656-7a710d99b9c9/3ae2e02d-57e7-42bd-8829-eb6a67043407_compressed_S__91709446_0.webp",
    blocks: [
      { type: "paragraph", text: "弊社の「乙御KABOS（おとみカボス）」と、旨みと食感が際立つ「雪国まいたけ」の夢のコラボレーションが実現いたしました！" },
      { type: "paragraph", text: "今回のコラボレーションは、雪国まいたけ様からお声かけをいただき、実際に臼杵市乙見のファームまで足を運んでいただきました。" },
      { type: "subheading", text: "日本を代表するきのこメーカー「雪国まいたけ」" },
      { type: "paragraph", text: "雪国まいたけ（ユキグニファクトリー株式会社）は、かつて“幻のきのこ”と言われたまいたけの栽培技術を確立した、日本を代表するきのこメーカーです。徹底した品質管理のもと、安全・安心で高品質なきのこづくりに取り組まれています。" },
      { type: "paragraph", text: "雪国まいたけは自社で開発した最高品質の菌床と、新潟の清らかな水・徹底管理された環境で手塩にかけて育てられた至高のまいたけです。" },
      { type: "paragraph", text: "身が非常に引き締まっており、加熱しても崩れない歯ごたえ抜群のシャキシャキ食感と、お料理全体を包み込む濃厚な旨みと香りが魅力です。" },
      { type: "image", src: "https://storage.helloreaddy.io/project_files/3947077b-25d2-4d94-b656-7a710d99b9c9/6eef6d9f-3a70-407c-bf61-ff99b3c51822_compressed_S__91709449_0.webp", alt: "乙御KABOS × 雪国まいたけ コラボポスター" },
      { type: "subheading", text: "かぼす×きのこの新発見" },
      { type: "paragraph", text: "「まいたけにフレッシュなかぼすをひと搾りすることで、まいたけ本来の旨みと香りがさらに引き立ち、格段に美味しくなる」そんな美味しさの新発見を、ぜひ皆さまの食卓にお届けしたいという想いから、売り場での販売が決定いたしました。" },
      { type: "paragraph", text: "この極上の旨みを持つ雪国まいたけに、爽快な酸味とまろやかな香りを持つ「乙御KABOS」をギュッと絞れば、お互いの良さを引き立て合う最高のペアリングが完成します！" },
      { type: "image", src: "https://storage.helloreaddy.io/project_files/3947077b-25d2-4d94-b656-7a710d99b9c9/a814d883-c2af-4390-8327-b2f96b8102ed_compressed_S__91709445_0.webp", alt: "かぼす×舞茸 コラボ企画の店頭ポスター" },
      { type: "image", src: "https://storage.helloreaddy.io/project_files/3947077b-25d2-4d94-b656-7a710d99b9c9/c54e5a91-083d-497a-8c29-410076b88ff4_compressed_S__91709447_0.webp", alt: "マルミヤストア店内の乙御KABOS×雪国まいたけ特設売り場" },
      { type: "image", src: "https://storage.helloreaddy.io/project_files/3947077b-25d2-4d94-b656-7a710d99b9c9/f1541caa-df9d-41be-b6a3-9f7b3fc419da_compressed_S__91709448_0.webp", alt: "乙御KABOSと雪国まいたけの並んだ売り場" },
      { type: "subheading", text: "販売店舗" },
      { type: "paragraph", text: "本コラボは、本日よりマルミヤストア 金池南店様にてお買い求めいただけます。" },
      { type: "paragraph", text: "ぜひセットでご賞味ください！" },
    ],
  },
  "012": {
    id: "012",
    date: "2026.09.10",
    category: "お知らせ",
    title: "東京ミッドタウン日比谷「DRAWING HOUSE OF HIBIYA」にて、「乙御KABOS」をふんだんに使用したメニューがスタート！",
    image: "https://storage.helloreaddy.io/project_files/3947077b-25d2-4d94-b656-7a710d99b9c9/dd64a112-3223-4616-9138-7dee576cc178_compressed_S__90923015_0.webp",
    blocks: [
      { type: "paragraph", text: "日頃よりご愛顧いただき、誠にありがとうございます。" },
      { type: "paragraph", text: "このたび、東京ミッドタウン日比谷6階に店舗を構える人気レストラン「DRAWING HOUSE OF HIBIYA」にて、弊社ブランドかぼす「乙御KABOS」を採用していただけることが決定いたしました。" },
      { type: "paragraph", text: "「DRAWING HOUSE OF HIBIYA」は、日比谷公園を一望できる贅沢なロケーションと空中庭園を併設した、都市の風を感じられる美しいレストランです。" },
      { type: "paragraph", text: "以前、大分県臼杵市にある弊社の「乙見ファーム」へ足をお運びいただき、丹精込めて育てる現場に触れていただいたご縁が実を結び、今回のメニュー採用へと繋がりました。" },
      { type: "subheading", text: "【「乙御KABOS」使用メニュー】" },
      { type: "image", src: "https://storage.helloreaddy.io/project_files/3947077b-25d2-4d94-b656-7a710d99b9c9/dd64a112-3223-4616-9138-7dee576cc178_compressed_S__90923015_0.webp", alt: "乙御KABOSを使ったかぼすタルト" },
      { type: "paragraph", text: "・かぼすタルト　かぼすの魅力をストレートに味わえる贅沢なタルト。" },
      { type: "image", src: "https://storage.helloreaddy.io/project_files/3947077b-25d2-4d94-b656-7a710d99b9c9/3a4fbc42-0541-4337-865f-0e838df48e0b_compressed_S__90923016_0.webp", alt: "海の幸/山の幸のパピヨット" },
      { type: "paragraph", text: "・海の幸/山の幸のパピヨット　スライスした「乙御KABOS」を、特製の「かぼすこしょうバター」とともに香り豊かに蒸しあげた一品。" },
      { type: "image", src: "https://storage.helloreaddy.io/project_files/3947077b-25d2-4d94-b656-7a710d99b9c9/b1c71661-a568-44b0-9190-e33c9ffd2fec_compressed_S__90923017_0.webp", alt: "ブリッタルガ / タリアテッレ" },
      { type: "paragraph", text: "・ブリッタルガ / タリアテッレ　仕上げに「乙御KABOS」のゼスト（果皮）を散らし、華やかな香りとアクセントをプラス。" },
      { type: "image", src: "https://storage.helloreaddy.io/project_files/3947077b-25d2-4d94-b656-7a710d99b9c9/c816add2-3a47-413e-8be6-7775bfe41659_compressed_S__90923018_0.webp", alt: "安心院シャインマスカットのデセール" },
      { type: "paragraph", text: "・安心院シャインマスカット（デセール）　「乙御KABOS」の果汁とゼストを贅沢に合わせた爽やかなクリームで仕立てたデザート。" },
      { type: "subheading", text: "■ シェフ・増田氏からのコメント" },
      { type: "paragraph", text: "「今回の大分県のコース料理は『大分食文化×温泉』をテーマにメニュー構成しています。その中で感じた、大分県民の皆様がかぼすを何にでもかけて楽しむスタイルからヒントを得て、料理の流れの繋ぎとしてかぼすを使用しました。香り、酸味、苦味、色合いのどれもが本当に素晴らしかったため、ふんだんに取り入れさせていただきました！」" },
      { type: "paragraph", text: "大分の風土とシェフの感性が織りなす特別なコースを、ぜひこの機会にご堪能ください。東京近郊にお住まいの方はもちろん、お仕事やご旅行で東京へお越しの際も、皆さまのご来店を心よりお待ちしております。" },
    ],
  },
  "011": {
    id: "011",
    date: "2026.09.01",
    category: "お知らせ",
    title: "【お知らせ】ANA限定返礼品に採択！臼杵市の返礼品として初の 「ANA限定バッジ」を取得！",
    image: "https://storage.helloreaddy.io/project_files/3947077b-25d2-4d94-b656-7a710d99b9c9/847e0d5d-7f7e-4069-ad37-6a5b387380b3_compressed_n1.webp",
    blocks: [
      { type: "paragraph", text: "このたび、弊社の贈答用「乙御KABOS（24玉入り）」が、全日空ANAが運営するポータルサイト「ANAのふるさと納税」において「ANA限定返礼品」に採択され、ANA限定バッジを付与していただきました。" },
      { type: "subheading", text: "「ANA限定バッジ」とは" },
      { type: "paragraph", text: "「ANA限定バッジ」は、「ANAのふるさと納税」に掲載される返礼品のなかで、同サイト限定で取り扱われる特別なお礼の品に付与されるマークです。" },
      { type: "paragraph", text: "臼杵市のふるさと納税返礼品において本バッジが付与されるのは、今回「乙御KABOS」が初めてとなります。" },
      { type: "image", src: "https://storage.helloreaddy.io/project_files/3947077b-25d2-4d94-b656-7a710d99b9c9/847e0d5d-7f7e-4069-ad37-6a5b387380b3_compressed_n1.webp", alt: "乙御KABOS 贈答用ギフトボックス" },
      { type: "subheading", text: "全国の皆様へお届け" },
      { type: "paragraph", text: "かぼす発祥の地とされる臼杵市乙見の豊かな自然のもと育んだブランドかぼすを、全国の皆様、そして旅を愛する多くの皆様へお届けできる機会をいただきましたこと、心より光栄に存じます。" },
      { type: "paragraph", text: "大切な方への季節のご挨拶や贈答用として、ぜひご利用ください。" },
      { type: "subheading", text: "今後の取り組み" },
      { type: "paragraph", text: "今後とも、臼杵市が誇るかぼす文化の価値向上と地域の魅力発信を目指し、一層の品質管理とブランド育成に取り組んでまいります。" },
      { type: "paragraph", text: "(※写真は12玉入りのイメージです。)" },
    ],
  },
  "010": {
    id: "010",
    date: "2026.09.01",
    category: "お知らせ",
    title: "【新商品販売開始のお知らせ】",
    image: "https://storage.helloreaddy.io/project_files/3947077b-25d2-4d94-b656-7a710d99b9c9/1bd9f269-eadb-483c-adf0-dec8836c886c_compressed_n.webp",
    blocks: [
      { type: "paragraph", text: "いつも株式会社OLカンパニーをご愛顧いただき、誠にありがとうございます。" },
      { type: "paragraph", text: "このたび、公式ECサイト・ならびに臼杵市ふるさと納税にて「乙御KABOS（おとみカボス）」贈答用の販売を開始いたしました。" },
      { type: "subheading", text: "「乙御KABOS」とは" },
      { type: "paragraph", text: "「乙御KABOS」は、かぼす発祥の地として知られる大分県臼杵市乙見地区で育まれた、こだわりのブランドかぼすです。" },
      { type: "paragraph", text: "今回販売する贈答用は、ひとつひとつ丁寧に育てられた果実の中から優れたものを厳選いたしました。" },
      { type: "image", src: "https://storage.helloreaddy.io/project_files/3947077b-25d2-4d94-b656-7a710d99b9c9/1bd9f269-eadb-483c-adf0-dec8836c886c_compressed_n.webp", alt: "乙御KABOS 贈答用ギフトボックス" },
      { type: "subheading", text: "特別な贈り物に最適" },
      { type: "paragraph", text: "箱を開けた瞬間に大分県を感じられる特別な贈り物に最適です。" },
      { type: "list", items: [
        "故郷を離れて暮らす方へ",
        "都会で頑張るご家族へ",
        "大切な方へ産地のこだわりが詰まった特別な「乙御KABOS」を、ぜひこの機会にご利用ください。",
      ]},
      { type: "paragraph", text: "皆様からのご注文を心よりお待ちしております。" },
      { type: "paragraph", text: "ご購入は株式会社OLカンパニー公式ECサイトから！" },
    ],
  },
  "009": {
    id: "009",
    date: "2026.08.29",
    category: "お知らせ",
    title: "【8/29 (土) アパレルブランド THANKSLOCAL RELEASE！】",
    image: "https://storage.helloreaddy.io/project_files/3947077b-25d2-4d94-b656-7a710d99b9c9/60988106-e21d-4216-ae58-86f45e370760_compressed_S__89645071_0.webp",
    blocks: [
      { type: "paragraph", text: "弊社のローカルアパレルブランド「THANKSLOCAL」から、今シーズンの新作Tシャツ2パターンが、本日より公式ECサイトにて販売スタートしました！" },
      { type: "paragraph", text: "地域を愛するすべての人へ、感謝と誇りを込めて。ローカルを愛する気持ちを共に表現しましょう！" },
      { type: "image", src: "https://storage.helloreaddy.io/project_files/3947077b-25d2-4d94-b656-7a710d99b9c9/df100d67-3325-4c4f-a49f-a681c3a4ae43_compressed_S__89645070_0.webp", alt: "THANKSLOCAL Tシャツ ライフスタイルショット" },
      { type: "subheading", text: "2パターンの新作Tシャツ" },
      { type: "paragraph", text: "今シーズンは2つのデザインをご用意しました。シンプルながらもTHANKSLOCALの世界観を表現した、日常に馴染むアイテムです。" },
      { type: "image", src: "https://storage.helloreaddy.io/project_files/3947077b-25d2-4d94-b656-7a710d99b9c9/60988106-e21d-4216-ae58-86f45e370760_compressed_S__89645071_0.webp", alt: "THANKSLOCAL Tシャツ アウトドアライフスタイル" },
      { type: "subheading", text: "デザインA：#THANKSLOCAL" },
      { type: "paragraph", text: "胸元に「#THANKSLOCAL」のロゴを配したシンプルデザイン。袖のタグもポイントになっています。BlackとWhiteの2色展開です。" },
      { type: "image", src: "https://storage.helloreaddy.io/project_files/3947077b-25d2-4d94-b656-7a710d99b9c9/98e51f8a-a2e5-4b2f-9a1e-de7476d402e1_compressed_S__89645065_0.webp", alt: "THANKSLOCAL Tシャツ White #THANKSLOCAL" },
      { type: "image", src: "https://storage.helloreaddy.io/project_files/3947077b-25d2-4d94-b656-7a710d99b9c9/c5e74f0f-88b5-4c15-b1f7-0ae96c13aebd_compressed_S__89645064_0.webp", alt: "THANKSLOCAL Tシャツ Black #THANKSLOCAL" },
      { type: "subheading", text: "デザインB：thanks local" },
      { type: "paragraph", text: "「thanks local」のロゴをデザインしたアイテム。背面のワンポイントも魅力です。BlackとWhiteの2色展開です。" },
      { type: "image", src: "https://storage.helloreaddy.io/project_files/3947077b-25d2-4d94-b656-7a710d99b9c9/a9f90bdb-74a2-4152-b235-0ba21b045eef_compressed_S__89645066_0.webp", alt: "THANKSLOCAL Tシャツ White thanks local フロント" },
      { type: "image", src: "https://storage.helloreaddy.io/project_files/3947077b-25d2-4d94-b656-7a710d99b9c9/9487b8e3-9d33-415d-aafa-766c96ffb13b_compressed_S__89645068_0.webp", alt: "THANKSLOCAL Tシャツ Black thanks local フロント" },
      { type: "image", src: "https://storage.helloreaddy.io/project_files/3947077b-25d2-4d94-b656-7a710d99b9c9/5dc5d25b-6968-48aa-86c5-40cd371eb22d_compressed_S__89645067_0.webp", alt: "THANKSLOCAL Tシャツ White thanks local バック" },
      { type: "image", src: "https://storage.helloreaddy.io/project_files/3947077b-25d2-4d94-b656-7a710d99b9c9/d7864a17-20ae-410c-98fc-c0b4a854678b_compressed_S__89645069_0.webp", alt: "THANKSLOCAL Tシャツ Black thanks local バック" },
      { type: "paragraph", text: "公式ECサイトにて販売を開始しております。ぜひECサイトをチェックしてください。" },
    ],
  },
  "008": {
    id: "008",
    date: "2026.08.01",
    category: "お知らせ",
    title: "【乙御KABOSが福岡県へ！】カフェ＆コミュニティスペース dot. にてお取扱い開始",
    image: "https://storage.helloreaddy.io/project_files/3947077b-25d2-4d94-b656-7a710d99b9c9/68cb4847-18a8-4278-ab7f-999bf419c997_compressed_S__89407535_0.webp",
    blocks: [
      { type: "subheading", text: "乙御KABOSが福岡・天神へ" },
      { type: "paragraph", text: "現在自社ブランド「乙御KABOS」を、福岡市天神大名にあるカフェ＆コミュニティスペース dot.（ドット）さんでお取り扱いしていただいております。" },
      { type: "paragraph", text: "dot.さんの素敵な空間にて「乙御KABOS」を展示していただいているほか、かぼすの爽やかな香りと酸味を活かしたメニューが多数登場しています！" },
      { type: "image", src: "https://storage.helloreaddy.io/project_files/3947077b-25d2-4d94-b656-7a710d99b9c9/6a17ab0c-18b8-4780-885b-25225528ece7_compressed_S__89407536_0.webp", alt: "dot. cafe 店内に展示された乙御KABOS" },
      { type: "subheading", text: " dot. さんの特製かぼすメニュー" },
      { type: "paragraph", text: "乙御KABOSならではの爽やかな香りと酸味を最大限に活かし、dot.さんのこだわりが詰まったメニューが登場しています。" },
      { type: "list", items: [
        "かぼすエスプレッソトニック",
        "かぼすジンジャーハニーソーダ",
        "かぼすシャーベットソーダ",
        "大分かぼすシャーベット",
      ]},
      { type: "image", src: "https://storage.helloreaddy.io/project_files/3947077b-25d2-4d94-b656-7a710d99b9c9/3bb089ed-ca12-45b2-9f5d-fa562b387a77_compressed_S__89407532_0.webp", alt: "dot. cafe かぼすドリンク" },
      { type: "image", src: "https://storage.helloreaddy.io/project_files/3947077b-25d2-4d94-b656-7a710d99b9c9/b4267504-5f0b-4e86-a557-a0b0ec292711_compressed_S__89407533_0.webp", alt: "dot. cafe 窓際のかぼすドリンク" },
      { type: "image", src: "https://storage.helloreaddy.io/project_files/3947077b-25d2-4d94-b656-7a710d99b9c9/6f8e0e02-6d42-415d-8215-0dd4bb166652_compressed_S__89407534_0.webp", alt: "dot. cafe かぼすドリンク" },
      { type: "paragraph", text: "福岡にお住まいの方や大名・天神近くにお越しの際は、ぜひ dot. さんにお立ち寄りください！" },
    ],
  },
  "007": {
    id: "007",
    date: "2026.08.01",
    category: "お知らせ",
    title: "【販売情報】大分県内スーパーマーケットで乙御KABOS取扱い開始",
    image: "https://storage.helloreaddy.io/project_files/3947077b-25d2-4d94-b656-7a710d99b9c9/15d34f39-863c-4177-9eee-afbbb5502240_compressed_S__89407529_0.webp",
    blocks: [
      { type: "subheading", text: "大分県内スーパーマーケットで取扱い開始" },
      { type: "paragraph", text: "このたび、かぼす発祥の地・大分県臼杵市産の「乙御KABOS（おとみカボス）」が、大分県内のスーパーマーケットにおきましてもお買い求めいただけることとなりましたのでご案内申し上げます。" },
      { type: "paragraph", text: "オンラインショップおよびふるさと納税での取扱いに加え、地域の皆様の日々の食卓へ、より手軽にフレッシュな乙御KABOSをお届けいたします。" },
      { type: "image", src: "https://storage.helloreaddy.io/project_files/3947077b-25d2-4d94-b656-7a710d99b9c9/9ae51e6a-b77e-433c-a66f-152114b88ff8_compressed_S__89407528_0.webp", alt: "乙御KABOS パッケージ" },
      { type: "subheading", text: "お取り扱い店舗（大分県内）" },
      { type: "list", items: [
        "マルミヤストア（一部店舗を除く）",
        "マックスバリュ（一部店舗を除く）",
      ]},
      { type: "paragraph", text: "※入荷状況や販売開始時期、お取り扱い数量は店舗によって異なる場合がございます。あらかじめご了承ください。" },
      { type: "image", src: "https://storage.helloreaddy.io/project_files/3947077b-25d2-4d94-b656-7a710d99b9c9/15d34f39-863c-4177-9eee-afbbb5502240_compressed_S__89407529_0.webp", alt: "乙御KABOS 青空の下のパッケージ" },
      { type: "paragraph", text: "丹念に育て上げた旬の香りと豊かな果汁を、ぜひお近くの店舗でお手にとってご賞味ください。" },
    ],
  },
  "006": {
    id: "006",
    date: "2026.08.01",
    category: "お知らせ",
    title: "【乙御KABOS販売情報】公式ECサイトがオープン",
    image: "https://storage.helloreaddy.io/project_files/3947077b-25d2-4d94-b656-7a710d99b9c9/948915cd-23a8-4ce2-8cd0-19133630ea78_compressed_S__89407524_0.webp",
    blocks: [
      { type: "subheading", text: "公式ECサイトが正式オープン" },
      { type: "paragraph", text: "かねてより準備を進めてまいりました「株式会社OLカンパニー 公式ECサイト」が正式にオープンいたしました。" },
      { type: "paragraph", text: "オープン直後より、さっそく多くのご注文や温かいメッセージをいただき、スタッフ一同心より感謝申し上げます。" },
      { type: "subheading", text: "旬の「乙御KABOS」2kg・4kgが販売スタート" },
      { type: "paragraph", text: "かぼす発祥の地・大分県臼杵市乙見より丹精込めて育てた自慢の「乙御KABOS」を、新鮮な状態で全国へお届けいたします。果汁たっぷりで爽やかな旬の香りを、ぜひご家庭やご贈答でお楽しみください。" },
      { type: "image", src: "https://storage.helloreaddy.io/project_files/3947077b-25d2-4d94-b656-7a710d99b9c9/948915cd-23a8-4ce2-8cd0-19133630ea78_compressed_S__89407524_0.webp", alt: "乙御KABOS かぼす農園での商品写真" },
      { type: "subheading", text: "【注目】人気の「グラノーラクッキー」もラインナップ！" },
      { type: "paragraph", text: "さらにショップオープンに合わせ、今年4月より大分空港様にて先行販売を行い、連日大好評をいただいている乙御KABOSを使った「かぼすのグラノーラクッキー」の全国通信販売をスタートいたしました。" },
      { type: "paragraph", text: "製造を手掛けたのは、卓越した技術と徹底した素材へのこだわりでファンを魅了し続ける「soiグラノーラ」。" },
      { type: "paragraph", text: "乙御KABOSならではの爽やかな甘酸っぱさと香りを最大限に活かし、香ばしいグラノーラのザクザク食感と見事に調和させた逸品です。手作業で丁寧に作られるからこその深い味わいと洗練された品質を、ぜひご堪能ください。" },
      { type: "image", src: "https://storage.helloreaddy.io/project_files/3947077b-25d2-4d94-b656-7a710d99b9c9/fe1b44a5-5bb4-448d-a598-de99680ad74a_compressed_S__89407525_0.webp", alt: "乙御KABOS 商品パッケージ" },
      { type: "subheading", text: "ふるさと納税でもご購入いただけます" },
      { type: "paragraph", text: "臼杵市ふるさと納税の返礼品としても乙御KABOSをご購入いただけます。以下のポータルサイトで受付を開始しております。" },
      { type: "list", items: [
        "ふるさとチョイス",
        "楽天ふるさと納税",
        "さとふる",
        "ふるなび",
        "ＡＮＡのふるさと納税",
        "JALふるさと納税",
        "ふるさとパレット",
        "auPAYふるさと納税",
        "セゾンのふるさと納税",
        "ふるラボ",
        "JREMALLふるさと納税",
        "KABU&ふるさと納税",
        "Vふるさと納税",
        "YAHOO!ふるさと納税",
      ]},
      { type: "paragraph", text: "今期も皆様へフレッシュなカボスと至高のスイーツをお届けできるよう努めてまいります。新しくスタートしたオンラインショップを、どうぞよろしくお願い申し上げます。" },
    ],
  },
  "005": {
    id: "005",
    date: "2026.06.12",
    category: "お知らせ",
    title: "森祐作代表が「うすきカボス応援大使」に就任",
    image: "https://storage.readdy-site.link/project_files/3947077b-25d2-4d94-b656-7a710d99b9c9/280df029-6b36-47dd-ac2b-e88dd0be4902_S__85295107_0.jpg",
    blocks: [
      { type: "subheading", text: "うすきカボス応援大使に就任" },
      { type: "paragraph", text: "この度、株式会社OLカンパニー代表取締役兼タレントの森祐作が、臼杵市の「うすきカボス応援大使」に就任いたしました。" },
      { type: "image", src: "https://storage.readdy-site.link/project_files/3947077b-25d2-4d94-b656-7a710d99b9c9/34bf4978-f026-4aea-abe8-82ac6641be7b_S__85295108_0.jpg", alt: "森祐作代表がカボスを手に" },
      { type: "paragraph", text: "弊社はかぼす発祥地・臼杵市乙見の耕作放棄地を切り拓き、2022年に企業参入。そこからファーム事業を立ち上げ、かぼすの生産、そして自社ブランド「乙御KABOS」のブランディングに邁進してまいりました。" },
      { type: "image", src: "https://storage.readdy-site.link/project_files/3947077b-25d2-4d94-b656-7a710d99b9c9/0dba4573-69b0-4758-b0c5-f8a053882af6_S__85295109_0.jpg", alt: "委嘱式での対面" },
      { type: "paragraph", text: "この任命は大変光栄であるとともに、より一層の責任を感じるものです。" },
      { type: "subheading", text: "「ローカルの輝きを世界へ」" },
      { type: "image", src: "https://storage.readdy-site.link/project_files/3947077b-25d2-4d94-b656-7a710d99b9c9/3cfefa4e-13d6-45c6-9b4a-5cf1d5255d7f_S__85295110_0.jpg", alt: "委嘱式の様子" },
      { type: "paragraph", text: "この信念を胸に、会社として、そしてタレントとして、かぼす発祥地・臼杵が誇るかぼす文化を国内外へ発信してまいります。" },
      { type: "image", src: "https://storage.readdy-site.link/project_files/3947077b-25d2-4d94-b656-7a710d99b9c9/8da7d15a-46d8-41ba-85c2-05d917a1e38c_S__85295111_0.jpg", alt: "屋外イベントの様子" },
      { type: "image", src: "https://storage.readdy-site.link/project_files/3947077b-25d2-4d94-b656-7a710d99b9c9/878b0ec8-ee42-4e67-a95e-86dfbc7cc55b_S__85295112_0.jpg", alt: "応援大使としての活動" },
      { type: "paragraph", text: "今後とも、森祐作ならびに株式会社OLカンパニーの挑戦を、温かく見守っていただければ幸いです。" },
      { type: "image", src: "https://storage.readdy-site.link/project_files/3947077b-25d2-4d94-b656-7a710d99b9c9/8d3fc00c-390e-4afd-b392-39c047107088_S__85295113_0.jpg", alt: "かぼすキャラクターと記念撮影" },
    ],
  },
  "004": {
    id: "004",
    date: "2026.04.20",
    category: "イベント",
    title: "春の収穫体験イベント開催",
    image: "https://static.readdy.ai/image/8da10c853ee44f0b201c0b84a1169777/ecac0c54302831045c8622edaa0f95e7.webp",
    blocks: [
      { type: "subheading", text: "大分の春を感じる収穫体験" },
      { type: "paragraph", text: "ファーム事業にて、春の収穫体験イベントを開催いたします。大分県の豊かな自然の中で、カボスの収穫体験をお楽しみいただけます。" },
      { type: "paragraph", text: "この時期だけの新鮮なカボスを、皆さま自身の手で収穫していただく体験型イベントです。収穫したカボスはその場で絞り、試飲もできます。" },
      { type: "image", src: "https://static.readdy.ai/image/8da10c853ee44f0b201c0b84a1169777/ecac0c54302831045c8622edaa0f95e7.webp", alt: "春の収穫体験" },
      { type: "subheading", text: "イベント詳細" },
      { type: "list", items: ["開催日: 2026年4月25日(土) 〜 4月27日(月)", "場所: OL Company ファーム（大分県）", "参加費: 無料", "定員: 各日30名様"] },
      { type: "paragraph", text: "お申し込みは公式SNSまたはお問い合わせフォームより承ります。定員になり次第締め切らせていただきますので、お早めにお申し込みください。" },
    ],
  },
};